import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './login.css';
const Login = () => {

    const navigate = useNavigate();

    const [data,setData]=useState({
        username:"",
        password:""
    });

    const handleChange=(e)=>{
        setData({
            ...data,
            [e.target.name]:e.target.value
        });
    };

    const handleSubmit=async(e)=>{

        e.preventDefault();

        try{

            const res=await axios.post(
                "http://localhost/api/login.php",
                data
            );

            if(res.data.success){

                localStorage.setItem(
                    "admin",
                    JSON.stringify(res.data.user)
                );

                navigate("/admin");

            }else{

                alert(res.data.message);

            }

        }catch(err){

            console.log(err);

            alert("Server Error");

        }

    };

    return(

        <div className="login-container">

            <form onSubmit={handleSubmit}>

                <h2>Admin Login</h2>

                <input
                type="text"
                name="username"
                placeholder="Username"
                onChange={handleChange}
                />

                <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                />

                <button type="submit">
                    Login
                </button>

            </form>

        </div>

    )

}

export default Login;